<template>
  <Modal :toggle="toggle">
    <div class="modal-tip">
      <img class="icon" src="../assets/icon-success.svg" />
      <h3 class="title">复制成功</h3>
      <p class="desc">您已成功复制微信号，是否立即跳转到微信搜索该微信号？</p>
      <div class="btn-group">
        <div class="btn cancel" @click="$emit('cancel')">取消</div>
        <div class="btn confirm" @click="$emit('confirm')">确定</div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Modal from '@/components/Modal';
@Component({
  components: {
    Modal,
  },
})
export default class ModalTip extends Vue {
  @Prop({ type: Boolean, default: false }) toggle!: boolean;
}
</script>

<style lang="scss" scoped>
.modal-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 630px;
  min-height: 580px;
  padding: 50px 0px;
  background-color: #ffffff;
  border-radius: 24px;
  .icon {
    width: 124px;
  }
  .title {
    margin-top: 13px;
    color: #404160;
    font-weight: 600;
    font-size: 42px;
  }
  .desc {
    width: 502px;
    margin-top: 41px;
    color: #212027;
    font-size: 30px;
    line-height: 1.5;
    text-align: center;
  }
  .btn-group {
    display: flex;
    margin-top: 59px;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 246px;
      height: 95px;
      font-weight: 600;
      font-size: 32px;
      border-radius: 8px;
    }
    .cancel {
      margin-right: 24px;
      color: #8680a3;
      border: solid 2px #8680a3;
      &:active {
        background: #ededed;
      }
    }
    .confirm {
      color: #fff;
      background: #00d18e;
      &:active {
        background: #01b279;
      }
    }
  }
}
</style>
